import axios from "axios";

export default {
    su1createSurvey(_, params) {
        return axios.post('/api/survey/su1/createsurvey', params, { withCredentials: true })
    },
    su2createSurvey(_, params) {
        return axios.post('/api/survey/su2/createsurvey', params, { withCredentials: true })
    },
    getSU2Elements(_, params) {
        return axios.post(`/api/element/getelements/${params.sector_id}`, 
        {
            is_deleted: params.is_deleted
        }, 
        { withCredentials: true })
    },
    getSU2Surveys(_, params) {
        return axios.post('/api/survey/su2/getsurveys', params, { withCredentials: true })
    },
    updateSurveySU2(_, params) {
      return axios.post(`/api/survey/su2/updatesurvey/${params.su2_survey_id}`, params.body, { withCredentials: true })},
    updateSU2SurveysFreq(_, params) {
        return axios.post(`/api/survey/su2/updatesurvey/${params.su2_survey_id}`, {
            reminder_frequency_day: params.reminder_frequency_day,
            updated_by: params.updated_by,
        }, {
           su2_survey_id: params.su2_survey_id,
           su2_survey_name: params.su2_survey_name,
           updated_by: params.updated_by
        }, 
        { withCredentials: true }
    )},
    deleteSurveySU2(_, params) {
        return axios.post('/api/survey/su2/deletesurvey', params, { withCredentials: true })
    },
    getUserToken(_, params) {
        return axios.get(`/api/survey/su2?token=${params.token}&user=${params.user}&id=${params.id}`, { withCredentials: true, 
            headers: {
                "Accept-Language": params.language
            }
        });
    },
    sendSurveyAnswers(_, params) {
        return axios.post('/api/survey/su2/sendsurveyanswers', params, { withCredentials: true })
    },
    postUserInfo(_, params) {
        return axios.post('/api/auth/getuserinfo', params, { withCredentials: true })
    },
    postSU2Elements(_, params) {
        return axios.post('api/survey/su2/createquestions', params, { withCredentials: true })
    },
    sendApprove(_, params) {
        return axios.post('/api/survey/su2/sendsurveyapprove', params, { withCredentials: true })
    },
    sendSurveySU2(_, params) {
        return axios.post('/api/survey/su2/sendsurvey', params, { withCredentials: true })
    },
    sendReminderSU1(_, params){
        return axios.post('/api/survey/su1/sendsurveyreminder', params, { withCredentials: true})
    },
    sendReminderSU2(_, params){
        return axios.post('/api/survey/su2/sendsurveyreminder', params, { withCredentials: true})
    },
    setSurveyId({ commit }, url) {
        commit('setSurveyId', url);
    },
    setSurveyToken({ commit }, url) {
        commit('setSurveyToken', url);
    },
    su1CreateResults(_, params) {
        return axios.post('/api/su1result/createresults', params, { withCredentials: true })
    },
    getUserTokenSU1(_, params) {
        return axios.get(`/api/survey/su1?token=${params.token}&user=${params.user}&id=${params.id}`, { withCredentials: true, 
            headers: {
                "Accept-Language": params.language
            }
        });
    },
    //surveysForApproval
    getSU2SurveysForApproval(_, params) {
        return axios.post('/api/survey/su2/getapproverequest', params, { withCredentials: true })
    },
    postApproveSurvey(_, params) {
        return axios.post('/api/survey/su2/approvesurvey', params, { withCredentials: true })
    },
    postRejectSurvey(_, params) {
        return axios.post('/api/survey/su2/rejectsurvey', params, { withCredentials: true })
    },
    getSU1Surveys(_, params) {
        return axios.post('/api/survey/su1/getsurveys', params, { withCredentials: true })
    },
    getSU1Details(_, params) {
        return axios.post('/api/survey/su1/getsurveydetails', params, { withCredentials: true })
    },
    getSU2Details(_, params) {
        return axios.post('/api/survey/su2/getsurveydetails', params, { withCredentials: true })
    },
    updateSurveySU1(_, params) {
        return axios.post(`/api/survey/su1/updatesurvey/${params.su1_survey_id}`, params.body, { withCredentials: true });
    },
    updateSU1SurveysFreq(_, params) {
        return axios.post(`/api/survey/su1/updatesurvey/${params.su1_survey_id}`, {
            reminder_frequency_day: params.reminder_frequency_day,
            updated_by: params.updated_by,
        }, {
           su1_survey_id: params.su1_survey_id,
           su1_survey_name: params.su1_survey_name,
           updated_by: params.updated_by
        }, 
        { withCredentials: true }
    )},
    deleteSurveySU1(_, params) {
        return axios.post('/api/survey/su1/deletesurvey', params, { withCredentials: true })
    },
    sendSurveySU1(_, params) {
        return axios.post('/api/survey/su1/sendsurvey', params, { withCredentials: true })
    },
    getSurveyQuestion(_, params) {
        return axios.post('/api/survey/su2/getsurveyquestions', params, { withCredentials: true })
    }, 
    editSurveyQuestion(_, params) {
        return axios.post('/api/survey/su2/editsurveyquestions', params, { withCredentials: true })
    },
    editPostSurveyQuestion(_, params) {
        return axios.post('api/survey/su2/updatesurveyquestions', params, { withCredentials: true })
    },
    myCreatedSurveys(_, params) {
        return axios.post('/api/survey/su2/getapproverequest', params, { withCredentials: true })
    },
    getCompanies(_,params) {
        return axios.post(`/api/company/getcompanieswusers/${params.user_id}`, 
        {is_deleted: params.is_deleted, role_id: params.role_id}, { withCredentials: true })
    },
    getCompanyLogoByCompanyId(_, params) {
        return axios.post("/api/company/getcompanylogobycompanyid", params, {responseType: 'blob', withCredentials: true});
    },

    getSU1Participation(_,params) {
        return axios.post(`/api/participation/getsu1surveyparticipationsbysurveyid`, params, { withCredentials: true })
    },
    updateSU1Participation(_,params) {
        return axios.post(`/api/participation/updatesu1surveyparticipation/${params.su1_survey_participation_id}`, 
        {
            receive_survey_link: params.receive_survey_link,
            updated_by: params.updated_by
        }
        , { withCredentials: true })
    },

    getSU2Participation(_,params) {
        return axios.post(`/api/participation/getsu2surveyparticipationsbysurveyid`, params, { withCredentials: true })
    },
    updateSU2Participation(_,params) {
        return axios.post(`/api/participation/updatesu2surveyparticipation/${params.su2_survey_participation_id}`, 
        {
            receive_survey_link: params.receive_survey_link,
            updated_by: params.updated_by
        }
        , { withCredentials: true })
    },
    updateSU2Reponsiveness(_, params){
        return axios.post(`/api/participation/updatesu2surveyparticipation/${params.su2_survey_participation_id}`, 
        {
            is_responsive: params.is_responsive,
            updated_by: params.updated_by
        }
        , { withCredentials: true })
    },
    completeSU1(_, params){
        return axios.post(`/api/survey/su1/completesurvey/${params.survey_id}`, params.body, { withCredentials: true }) 
        /* 
        body: {
            is_completed: --bool,
            updated_by: --int
        }  
        */
    },
    completeSU2(_, params){
        return axios.post(`/api/survey/su2/completesurvey/${params.survey_id}`, params.body, { withCredentials: true })
    },

    sendSu1ToNonReceivers(_, params){
        return axios.post(`/api/survey/su1/sendsurveytononreceivers`, params, { withCredentials: true })
    },
    sendSu2ToNonReceivers(_, params){
        return axios.post(`/api/survey/su2/sendsurveytononreceivers`, params, { withCredentials: true })
    },

    downloadSu1Participants(_, params) {
        return axios.post("/api/participation/downloadsu1surveyxls", params, { responseType: "blob" });
    },

    downloadSu2Participants(_, params) {
        return axios.post("/api/participation/downloadsu2surveyxls", params, { responseType: "blob" });
    }
}
